enum GraphicsType {
	RECTANGLE,
	ROUNDEDRECTANGLE,
	CIRCLE,
	ELLIPSE,
	POLYGON,
}

export class SpriteGraphics {
	public static makeRectangle(width: number, height: number, color: number = 0xffffff, alpha: number = 1): PIXI.Sprite {
		const sprite = this.makeGraphics({type: GraphicsType.RECTANGLE, width, height}, color, alpha);

		return sprite;
	}

	public static makeHiddenRectangle(width: number, height: number): PIXI.Sprite {
		const graphicsObject = new PIXI.Graphics();
		graphicsObject.drawRect(0, 0, width, height);
		const spriteObject = new PIXI.Sprite(graphicsObject.generateCanvasTexture());
		graphicsObject.destroy();

		return spriteObject;
	}

	public static makeRoundedRectangle(width: number, height: number, radius: number, color: 0xffffff, alpha: number = 1): PIXI.Sprite {
		const sprite = this.makeGraphics({type: GraphicsType.ROUNDEDRECTANGLE, width, height, radius}, color, alpha);

		return sprite;
	}

	public static makeCircle(radius: number, color: number, alpha: number): PIXI.Sprite {
		const sprite = this.makeGraphics({type: GraphicsType.CIRCLE, radius}, color, alpha);

		return sprite;
	}
	public static makeHiddenCircle(radius: number): PIXI.Sprite {
		const graphicsObject = new PIXI.Graphics();
		graphicsObject.drawCircle(0, 0, radius);
		const spriteObject = new PIXI.Sprite(graphicsObject.generateCanvasTexture());
		graphicsObject.destroy();

		return spriteObject;
	}

	public static makeEllipse(width: number, height: number, color: number, alpha: number): PIXI.Sprite {
		const sprite = this.makeGraphics({type: GraphicsType.ELLIPSE, width, height}, color, alpha);

		return sprite;
	}

	public static makeHiddenEllipse(width: number, height: number): PIXI.Sprite {
		const graphicsObject = new PIXI.Graphics();
		graphicsObject.drawEllipse(0, 0, width, height);
		const spriteObject = new PIXI.Sprite(graphicsObject.generateCanvasTexture());
		graphicsObject.destroy();

		return spriteObject;
	}

	protected static makeGraphics(data: any, color: number = 0xffffff, alpha: number = 1): PIXI.Sprite {
		const graphicsObject = new PIXI.Graphics();

		graphicsObject.beginFill(color, alpha);
		switch (data.type) {
			case GraphicsType.RECTANGLE:
				graphicsObject.drawRect(0, 0, data.width, data.height);
				break;
			case GraphicsType.ROUNDEDRECTANGLE:
				graphicsObject.drawRoundedRect(0, 0, data.width, data.height, data.radius);
				break;
			case GraphicsType.CIRCLE:
				graphicsObject.drawCircle(0, 0, data.radius);
				break;
			case GraphicsType.ELLIPSE:
				graphicsObject.drawEllipse(0, 0, data.width, data.height);
				break;
			default:
				graphicsObject.drawRect(0, 0, 100, 100);
				break;
		}

		graphicsObject.endFill();
		const graphicsSprite = new PIXI.Sprite(graphicsObject.generateCanvasTexture());
		graphicsObject.destroy();

		return graphicsSprite as PIXI.Sprite;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/core/src/display/SpriteGraphics.ts